/* __next_internal_client_entry_do_not_use__ MarketplaceProduct auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useAssignPersistQuickAddOnSearchTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TileEffects/useAssignPersistQuickAddOnSearchTile";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { productClickForSearchPageParametersILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickForSearchPage";
import { DiscoveryProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/index";
import { useProductTileClickImpressions } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/useProductTileClickImpressions";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { SignUpElement, SignUpType, useTrackSignupModalOpenClick } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { useSettingPersistQuickAddOnSearchTile } from "@faire/retailer-visitor-shared/settings/useSettingPersistQuickAddOnSearchTile";
import { preloadNavigationToPDP } from "@faire/retailer-visitor-shared/views/product/preload/preloadNavigationToPDP";
import { PRODUCT_GRID_IMAGE_BREAKPOINTS } from "@faire/retailer-visitor-shared/views/search/const";
import { useEffectEvent } from "@faire/web--source/ui/hooks/useEffectEvent";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { useQueryClient } from "@tanstack/react-query";
import * as React from "react";
import { useRef } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
var MarketplaceProductLoggedIn = function(props) {
    var _productTile_product;
    var recordAdImpression = props.recordAdImpression, productTile = props.productTile, brand = props.brand, onQuickAdd = props.onQuickAdd, onQuickAddSubmit = props.onQuickAddSubmit, onChooseOption = props.onChooseOption, onHeartClicked = props.onHeartClicked, onSaveToBoard = props.onSaveToBoard, onRemoveFromBoard = props.onRemoveFromBoard, onChooseOptionQuantityUpdate = props.onChooseOptionQuantityUpdate, generateBrandUrl = props.generateBrandUrl, generateProductLinkProps = props.generateProductLinkProps, showVerticalImagery = props.showVerticalImagery, onClick = props.onClick, onProductVisible = props.onProductVisible, shouldShowPromotedBadge = props.shouldShowPromotedBadge, altTag = props.altTag, imageDimension = props.imageDimension, shouldHideSaveToBoard = props.shouldHideSaveToBoard, imageBreakpoints = props.imageBreakpoints;
    var _useProductTileClickImpressions = useProductTileClickImpressions(productClickForSearchPageParametersILeanProductTileAdapter(productTile), brand === null || brand === void 0 ? void 0 : brand.token, recordAdImpression), recordProductBadgeViewEvent = _useProductTileClickImpressions.recordProductBadgeViewEvent, recordBrandNameClickEvent = _useProductTileClickImpressions.recordBrandNameClickEvent, recordProductTileClickEvent = _useProductTileClickImpressions.recordProductTileClickEvent, recordProductTileMiddleClickEvent = _useProductTileClickImpressions.recordProductTileMiddleClickEvent, recordHeartClickedEvent = _useProductTileClickImpressions.recordHeartClickedEvent, recordProductTileRightClickEvent = _useProductTileClickImpressions.recordProductTileRightClickEvent, recordSaveToBoardSubmitEvent = _useProductTileClickImpressions.recordSaveToBoardSubmitEvent, recordRemoveFromBoardSubmitEvent = _useProductTileClickImpressions.recordRemoveFromBoardSubmitEvent, recordQuickAddButtonClickEvent = _useProductTileClickImpressions.recordQuickAddButtonClickEvent, recordQuickAddSubmitEvent = _useProductTileClickImpressions.recordQuickAddSubmitEvent, recordChooseOptionClickEvent = _useProductTileClickImpressions.recordChooseOptionClickEvent, recordChooseOptionQuantityUpdateSubmitEvent = _useProductTileClickImpressions.recordChooseOptionQuantityUpdateSubmitEvent;
    var viewport = useViewport();
    var location = useLocation();
    var topLeftTileBadge = useRef(undefined);
    var queryClient = useQueryClient();
    var onTopLeftTileBadgeVisible = function(tileBadge) {
        var _productTile_product;
        recordProductBadgeViewEvent();
        topLeftTileBadge.current = tileBadge;
        onProductVisible === null || onProductVisible === void 0 ? void 0 : onProductVisible(productTile === null || productTile === void 0 ? void 0 : (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token, tileBadge);
    };
    var onProductClick = useEffectEvent(function(productTile, event) {
        var _productTile_product;
        preloadNavigationToPDP(queryClient, {
            productToken: (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token,
            bestImage: productTile.best_image,
            images: productTile.images,
            showVerticalImagery: showVerticalImagery
        });
        recordProductTileClickEvent();
        if (productTile.product) {
            onClick === null || onClick === void 0 ? void 0 : onClick(productTile.product, event);
        }
    });
    var onBrandClick = function(event) {
        recordBrandNameClickEvent();
        if ((productTile === null || productTile === void 0 ? void 0 : productTile.product) && props.onBrandClick) {
            props.onBrandClick(productTile.product.token, productTile.product.brand_token, productTile.product.is_promoted, productTile.product.promoted_by, productTile.product.impression_id);
        }
        event.stopPropagation();
    };
    var handleOnAuxClick = useEffectEvent(function(event) {
        if (event.button === 1) {
            recordProductTileMiddleClickEvent();
        } else if (event.button === 2) {
            recordProductTileRightClickEvent();
        }
    });
    var handleOnHeartClicked = function() {
        recordHeartClickedEvent();
        onHeartClicked === null || onHeartClicked === void 0 ? void 0 : onHeartClicked();
    };
    var handleOnSaveToBoard = function(boardToken) {
        recordSaveToBoardSubmitEvent(boardToken);
        onSaveToBoard === null || onSaveToBoard === void 0 ? void 0 : onSaveToBoard(boardToken);
    };
    var handleOnRemoveFromBoard = function(boardToken) {
        recordRemoveFromBoardSubmitEvent(boardToken);
        onRemoveFromBoard === null || onRemoveFromBoard === void 0 ? void 0 : onRemoveFromBoard(boardToken);
    };
    var handleQuickAdd = function(newQuantity) {
        recordQuickAddButtonClickEvent();
        onQuickAdd === null || onQuickAdd === void 0 ? void 0 : onQuickAdd(newQuantity);
    };
    var handleQuickAddSubmit = function(newQuantity) {
        recordQuickAddSubmitEvent(newQuantity);
        onQuickAddSubmit === null || onQuickAddSubmit === void 0 ? void 0 : onQuickAddSubmit(newQuantity);
    };
    var handleChooseOption = function() {
        recordChooseOptionClickEvent();
        onChooseOption === null || onChooseOption === void 0 ? void 0 : onChooseOption();
    };
    var handleChooseOptionQuantityUpdate = function(newQuantity) {
        recordChooseOptionQuantityUpdateSubmitEvent(newQuantity);
        onChooseOptionQuantityUpdate === null || onChooseOptionQuantityUpdate === void 0 ? void 0 : onChooseOptionQuantityUpdate(newQuantity);
    };
    var productLinkProps = (productTile === null || productTile === void 0 ? void 0 : (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token) ? generateProductLinkProps === null || generateProductLinkProps === void 0 ? void 0 : generateProductLinkProps(productTile.product.token, location) : undefined;
    useAssignPersistQuickAddOnSearchTile();
    var persistQuickAddSettingValue = useSettingPersistQuickAddOnSearchTile();
    var hideAddToCartAndNotifyMe = !persistQuickAddSettingValue && viewport.isMobile;
    return /*#__PURE__*/ _jsx(DiscoveryProductTile, {
        productTile: productTile,
        showVerticalImagery: props.showVerticalImagery,
        brand: brand,
        onBrandLinkClick: onBrandClick,
        generateBrandUrl: generateBrandUrl,
        onProductLinkClick: onProductClick,
        onAuxClick: handleOnAuxClick,
        onTopLeftBadgeVisible: onTopLeftTileBadgeVisible,
        altText: altTag,
        productLinkProps: productLinkProps,
        shouldShowPromotedBadge: shouldShowPromotedBadge,
        onHeartClicked: handleOnHeartClicked,
        onSaveToBoard: handleOnSaveToBoard,
        onRemoveFromBoard: handleOnRemoveFromBoard,
        onQuickAdd: handleQuickAdd,
        onQuickAddSubmit: handleQuickAddSubmit,
        onChooseOption: handleChooseOption,
        onChooseOptionQuantityUpdate: handleChooseOptionQuantityUpdate,
        hideAddToCartAndNotifyMe: hideAddToCartAndNotifyMe,
        recordAdImpression: recordAdImpression,
        imageDimension: imageDimension,
        shouldHideSaveToBoard: shouldHideSaveToBoard,
        imageBreakpoints: imageBreakpoints
    });
};
var MarketplaceProductLoggedOut = function(param) {
    var recordAdImpression = param.recordAdImpression, productTile = param.productTile, brand = param.brand, generateBrandUrl = param.generateBrandUrl, generateProductLinkProps = param.generateProductLinkProps, showVerticalImagery = param.showVerticalImagery, onClick = param.onClick, onProductVisible = param.onProductVisible, altTag = param.altTag, imageBreakpoints = param.imageBreakpoints, onBrandClick = param.onBrandClick;
    var _productTile_product;
    var _useProductTileClickImpressions = useProductTileClickImpressions(productClickForSearchPageParametersILeanProductTileAdapter(productTile), brand === null || brand === void 0 ? void 0 : brand.token, recordAdImpression), recordProductBadgeViewEvent = _useProductTileClickImpressions.recordProductBadgeViewEvent, recordProductTileClickEvent = _useProductTileClickImpressions.recordProductTileClickEvent, recordProductTileMiddleClickEvent = _useProductTileClickImpressions.recordProductTileMiddleClickEvent, recordProductTileRightClickEvent = _useProductTileClickImpressions.recordProductTileRightClickEvent, recordBrandNameClickEvent = _useProductTileClickImpressions.recordBrandNameClickEvent;
    var location = useLocation();
    var recordSignUpModalOpenClickEvent = useTrackSignupModalOpenClick();
    var topLeftTileBadge = useRef(undefined);
    var queryClient = useQueryClient();
    var onTopLeftTileBadgeVisible = function(tileBadge) {
        var _productTile_product;
        recordProductBadgeViewEvent();
        topLeftTileBadge.current = tileBadge;
        onProductVisible === null || onProductVisible === void 0 ? void 0 : onProductVisible(productTile === null || productTile === void 0 ? void 0 : (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token, tileBadge);
    };
    var handleOnProductClick = useEffectEvent(function(productTile, event) {
        var _productTile_product;
        recordProductTileClickEvent();
        preloadNavigationToPDP(queryClient, {
            productToken: (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token,
            bestImage: productTile.best_image,
            images: productTile.images,
            showVerticalImagery: showVerticalImagery
        });
        if (productTile.product) {
            onClick === null || onClick === void 0 ? void 0 : onClick(productTile.product, event);
        }
        recordSignUpModalOpenClickEvent(SignUpType.PRODUCT, SignUpElement.PRODUCT_GRID, "logged_out_product_tile");
    });
    var productLinkProps = (productTile === null || productTile === void 0 ? void 0 : (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token) ? generateProductLinkProps === null || generateProductLinkProps === void 0 ? void 0 : generateProductLinkProps(productTile.product.token, location) : undefined;
    var onBrandLinkClick = function(event) {
        recordBrandNameClickEvent();
        if ((productTile === null || productTile === void 0 ? void 0 : productTile.product) && onBrandClick) {
            onBrandClick(productTile.product.token, productTile.product.brand_token, productTile.product.is_promoted, productTile.product.promoted_by, productTile.product.impression_id);
        }
        event.stopPropagation();
    };
    var handleOnAuxClick = useEffectEvent(function(event) {
        if (event.button === 1) {
            recordProductTileMiddleClickEvent();
        } else if (event.button === 2) {
            recordProductTileRightClickEvent();
        }
    });
    return /*#__PURE__*/ _jsx(DiscoveryProductTile, {
        productTile: productTile,
        onBrandLinkClick: onBrandLinkClick,
        showVerticalImagery: showVerticalImagery,
        brand: brand,
        generateBrandUrl: generateBrandUrl,
        onProductLinkClick: handleOnProductClick,
        onAuxClick: handleOnAuxClick,
        onTopLeftBadgeVisible: onTopLeftTileBadgeVisible,
        altText: altTag,
        productLinkProps: productLinkProps,
        shouldShowPromotedBadge: false,
        recordAdImpression: recordAdImpression,
        imageBreakpoints: imageBreakpoints
    });
};
var MarketplaceProductBase = function(props) {
    if (isLoggedInRetailer()) {
        return /*#__PURE__*/ _jsx(MarketplaceProductLoggedIn, _object_spread_props(_object_spread({}, props), {
            imageBreakpoints: PRODUCT_GRID_IMAGE_BREAKPOINTS
        }));
    }
    return /*#__PURE__*/ _jsx(MarketplaceProductLoggedOut, _object_spread_props(_object_spread({}, props), {
        imageBreakpoints: PRODUCT_GRID_IMAGE_BREAKPOINTS
    }));
};
export var MarketplaceProduct = styled(MarketplaceProductBase).withConfig({
    componentId: "sc-3198f282-0"
})([
    ""
]);
